import { render, staticRenderFns } from "./ManualPdfViewer.vue?vue&type=template&id=615c99d8"
import script from "./ManualPdfViewer.vue?vue&type=script&lang=js"
export * from "./ManualPdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports